export const controllerGlobalContext = {
    dispatchActive: null,
    active: null
}